type SessionTeardownFn = () => void;

let onSessionExpired: SessionTeardownFn | null = null;

export const registerSessionTeardown = (fn: SessionTeardownFn): void => {
  onSessionExpired = fn;
};

export const triggerSessionTeardown = (): void => {
  onSessionExpired?.();
};
